// @ts-nocheck
function parseCourseSeconds(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds / 60) % 60);

  let timeStr = `${minutes}m`;

  if (hours) {
    timeStr = `${hours}h ${timeStr}`;
  }
  return timeStr;
}

export default parseCourseSeconds;
